/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetAllAccessRequestsLogsResponse } from '../models/GetAllAccessRequestsLogsResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class AccessRequestLogsControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetAllAccessRequestsLogsResponse
     * @throws ApiError
     */
    public accessRequestLogsControllerv2GetAllAccessRequestsLogs(): Observable<Array<GetAllAccessRequestsLogsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/accesslog',
        });
    }
}
